import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import AssetInwardChild from "./AssetInwardChild";

const AssetInward = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <AssetInwardChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default AssetInward;
